export const WORKOUT_KEY = "workout-key";

export const saveWorkout = (workout) => localStorage.setItem(WORKOUT_KEY, JSON.stringify(workout));

export const clearWorkout = () => localStorage.removeItem(WORKOUT_KEY);

export const getWorkout = () => JSON.parse(localStorage.getItem(WORKOUT_KEY));





// WEBPACK FOOTER //
// ./src/utils/workoutStore.js